import { z } from 'zod';

export const REVERSAL_NOTE_MAX_LENGTH = 5000;

export const reverseInvoiceSchema = z.object({
    note: z
        .string()
        .trim()
        .min(1, 'Enter a note explaining why the invoice is being reversed')
        .max(REVERSAL_NOTE_MAX_LENGTH, `The note cannot exceed ${REVERSAL_NOTE_MAX_LENGTH} characters`),
});

export type ReverseInvoiceFormInput = z.input<typeof reverseInvoiceSchema>;
export type ReverseInvoiceFormValues = z.output<typeof reverseInvoiceSchema>;
